<template>
  <div class="v-not-found">
    <div class="svg_wrapper">
      <inline-svg src="/themes/current/images/404.svg" :style="imgOpacity" @loaded="svgLoaded()" />
    </div>
    <div>
      <h1>{{ title }}</h1>
      <p>{{ message }}</p>
    </div>
    <div v-if="showBackToHome">
      <adn-button kind="primary" markup="router-link" :route="button.route">{{ button.text }}</adn-button>
    </div>
    <div v-if="optionalButton">
      <adn-button kind="primary" markup="router-link" :route="optionalButton.route">
        {{ optionalButton.text }}
      </adn-button>
    </div>
  </div>
</template>
<script lang="ts">
import InlineSvg from 'vue-inline-svg'
import { defineComponent } from 'vue'
import type { PropType } from 'vue'
import AdnButton from '@b2ag/design-system/src/components/AdnButton/AdnButton.vue'
import { useHead } from '#imports'

export interface ButtonData {
  route: string
  text: string
}

export default defineComponent({
  name: 'VNotFound',
  components: {
    InlineSvg,
    AdnButton,
  },
  props: {
    title: {
      type: String,
      default: 'Oups ! Il semble que la page que vous cherchez n’existe pas. ',
    },
    message: {
      type: String,
      default: 'Retournez à l’accueil pour continuer vos recherches.',
    },
    button: {
      type: Object as PropType<ButtonData>,
      default: () => ({
        route: '/',
        text: "Retour à l'accueil",
      }),
    },
    optionalButton: {
      type: Object as PropType<ButtonData>,
      required: false,
    },
    analytics: {
      type: Boolean,
      default: true,
    },
    showBackToHome: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    useHead({
      meta: [{ name: 'prerender-status-code', content: '404' }],
    })
    return {
      imgOpacity: 0,
    }
  },
  methods: {
    svgLoaded() {
      this.imgOpacity = 1
    },
  },
})
</script>
<style scoped lang="scss">
.v-not-found {
  height: 470px;
  margin: var(--spacing-4);
  display: flex;
  flex-direction: column;

  h1 {
    font-size: large;
    text-align: center;
  }

  > div {
    margin: var(--spacing-2) auto;
  }

  .svg_wrapper {
    height: 30rem;
  }

  :deep(svg) {
    max-width: 100%;
    width: 40rem;
    height: 30rem;
    margin: auto;

    &#COUNTRYMALT_404 {
      path {
        fill: var(--color-main-dark);

        &.background-shadows {
          fill: var(--color-decorative-main);
        }
      }
    }
  }
}

p {
  text-align: center;
}
</style>
